import React, {Component} from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import {Button, DropdownButton, MenuItem} from 'react-bootstrap';

import * as StringHelper from 'js/common/string_helper';

import IconLockGrey from 'images/icons/icon-lock-grey2x.png';

export default class PinterestAdModeSubmissionCTA extends Component {
    static propTypes = {
        shareOptions: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.shape({
                pinterest_ads: PropTypes.shape({
                    boards: PropTypes.arrayOf(
                        PropTypes.shape({
                            id: PropTypes.string.isRequired,
                            name: PropTypes.string.isRequired
                        })
                    ),
                    is_connected: PropTypes.bool.isRequired,
                    verify_url: PropTypes.string.isRequired
                })
            })
        ]),
        handleBoardSelected: PropTypes.func.isRequired,
        handleShowConnectToPlatform: PropTypes.func.isRequired
    };

    static createMenuItemForBoard({id, name, isLocked}) {
        const lockMaybe = isLocked ? (
            <img className="lock-icon-gray" role="presentation" src={IconLockGrey} />
        ) : null;

        const truncatedName = StringHelper.truncate(name, 30);

        return (
            <MenuItem key={id} className="pinterest-board-menuitem text-center" eventKey={id}>
                <span className="menuitem-name">{truncatedName}</span>
                <div className="pull-right">{lockMaybe}</div>
            </MenuItem>
        );
    }

    isPinterestAuthenticated = () =>
        Boolean(R.path(['shareOptions', 'pinterest_ads', 'is_connected'], this.props));

    render() {
        const {handleBoardSelected, handleShowConnectToPlatform} = this.props;

        /**
         * If you're not the right user type, pinterest_ads won't be available to you
         * so your button should be useless.
         */
        if (!this.isPinterestAuthenticated()) {
            return (
                <Button onClick={handleShowConnectToPlatform} bsStyle="pinterest">
                    Publish To Pinterest
                </Button>
            );
        }

        return R.pipe(
            R.path(['pinterest_ads', 'boards']),
            R.map(PinterestAdModeSubmissionCTA.createMenuItemForBoard),
            R.prepend(
                <MenuItem className="pinterest-board-menuitem header" header key="header">
                    Choose a board to pin to
                </MenuItem>
            ),
            R.append(
                <MenuItem
                    className="pinterest-board-menuitem text-center create-board"
                    eventKey="create-board"
                    key="create-board"
                >
                    + Create Board
                </MenuItem>
            ),
            menuItems => (
                <DropdownButton
                    bsStyle="pinterest"
                    id="pinterest-cta"
                    onSelect={handleBoardSelected}
                    title="Publish To Pinterest"
                    noCaret
                >
                    {menuItems}
                </DropdownButton>
            )
        )(this.props.shareOptions);
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/submission_ctas/pinterest.js